import * as React from "react";
import { toast, ToastContainer } from "react-toastify";
import Modal from "react-awesome-modal";

import withServices from "../../../../HOCs/withServices";
import NavBar from "../../../../components/CustomNav/CustomNav.Component";
import DatePicker from "../../../../components/DatePicker/DatePickerComponent";
import Calendly from "../../../../components/CalendlyBooking/CalendlyBooking.Component";
import schoolBg from "../../../../assets/images/parentreg/schoolbg.jpg";
import resultsBg from "../../../../assets/images/parentreg/results-bg.jpg";
import plexlogo from "../../../../assets/images/plex_new.png";

import {
  Container,
  FormContainer,
  FormWrapper,
} from "../../Common/Common.styles";
import {
  Heading,
  InputWrapper,
} from "../Registration/SchoolRegistration.styles";

import { TooltipParagraph } from '../../Parent/Registration/ParentRegistration.styles'

import {
  Row,
  Section,
  Col2,
} from "../../Parent/Registration/ParentRegistration.styles";

import {
  Grid,
  Filter,
  BorderButton,
  PixlFooter,
  CheckedItem
} from "../PiXLRegistration/PixlRegistration.styles";

import { currentBaseUrl, saveItem } from "../../../../common/services";
import {
  CURRENTUSERID,
  CURRENTUSERNAME,
  PROFILEKEY,
  SUBSCRIPTIONKEY,
  TOKENKEY,
  CURRENTDESIGNATION,
} from "../../../../common/constants";

interface IProps {
  services?: any;
  history?: any;
  match?: any;
}

const filters = [
  "Confidence",
  "Stress & Strain",
  "Retaining & Recalling Information",
  "Organisation & Time Management",
  "Focus & Motivation",
  "Sleep & Tiredness",
  "Exam Anxiety",
];

const PACKAGE_ID = 19;

class PixlRegistration extends React.Component<IProps> {
  public state = {
    password: "",
    institutiontype: null,
    email: "",
    schoolname: "",
    phone: "",
    dateObj: null as any,
    schoolyear: null,
    startDate: "",
    institutionTypes: [] as any,
    calendlyModal: false,
  };

  private registerRef = React.createRef<HTMLDivElement>();

  constructor(props) {
    super(props);
    this.navigate = this.navigate.bind(this);
    this.registerSchool = this.registerSchool.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.fetchUserInfo = this.fetchUserInfo.bind(this);
    this.registerSchool = this.registerSchool.bind(this);
  }

  public async componentDidMount() {
    const {
      history,
      services: {
        isUserLoggedIn,
        institutionsAPI,
        currentBaseUrl,
        currentDesignation,
        isUserUpgraded,
      },
    } = this.props;

    if (isUserLoggedIn) {
      if (isUserUpgraded) {
        this.navigate("school/home");
      }
    }

    const typesRes = await institutionsAPI.getInstitutionTypes();
    if (typesRes.ok) {
      const institutionTypes = typesRes.data.types;
      this.setState({ institutionTypes });
    }

    console.log(typesRes);
    console.log(this.props);
  }

  public onScroll = (target) => {
    console.log({ target });
    if (target.current === null) {
      console.log("Not scrolling...");
      return;
    }
    console.log("scrolling...", this.registerRef);
    window.scrollTo({
      left: 0,
      top: target.current.offsetTop,
      behavior: "smooth",
    });
  };

  public toggleCalendly = () => {
    const { calendlyModal } = this.state;
    this.setState({ calendlyModal: !calendlyModal });
  };

  public handleChange(event) {
    const currentField = event.target.dataset.arg;
    this.state[currentField] = event.target.value;
    console.info(this.state[currentField]);
  }

  public ageChangeHandler = (dateObj) => {
    const startDate = `${dateObj.year}-${dateObj.month}-${dateObj.day}`;
    this.setState({ dateObj, startDate });
  };

  public navigate(destination) {
    const { history } = this.props;
    history.push(destination);
  }

  public async registerSchool(event) {
    event.preventDefault();
    const {
      email,
      schoolname,
      password,
      institutiontype,
    } = this.state;

    const item = {
      email,
      institution_type: institutiontype,
      password,
      school_name: schoolname,
      selected_package: PACKAGE_ID
    };


    const regRes = await this.props.services.institutionsAPI.signUpInstitutionPromotional(item);
    
    console.log(regRes);
    if (regRes.ok) {
      saveItem(PROFILEKEY, regRes.data.profile);
      saveItem(SUBSCRIPTIONKEY, regRes.data.subscription);
      saveItem(TOKENKEY, regRes.data.token);
      saveItem(CURRENTDESIGNATION, regRes.data.designation);
      saveItem(PROFILEKEY, regRes.data.profile);
      saveItem(CURRENTUSERNAME, regRes.data.userinfo.username);
      saveItem(CURRENTUSERID, regRes.data.userinfo.id);
      this.props.history.push(`${currentBaseUrl()}home`);
    } else {
      toast.error("Sign up failed, check your details!");
    }
  }

  public async fetchUserInfo() {
    // coming
    const infoRes = await this.props.services.adminAPI.fetchUserInfo();
    console.log(infoRes);
    if (infoRes.ok) {
      // breakdown
    } else {
      window.location.reload();
    }
  }

  public renderCalendlyPopup = () => {
    return (
      <Modal
        visible={this.state.calendlyModal}
        effect="fadeInDown"
        onClickAway={this.toggleCalendly}
      >
        <Calendly url="https://calendly.com/performance_learning/welcome-to-plex?background_color=2a2a2a&text_color=ffffff&primary_color=acff24" />
      </Modal>
    );
  };

  public render() {
    const { institutionTypes } = this.state;
    return (
      <Container height="auto" background={schoolBg}>
        <ToastContainer />
        <NavBar />
        {this.renderCalendlyPopup()}
        <Section
          backgroundImage="linear-gradient(45deg, rgba(36, 230, 248, .8), rgba(36, 230, 248, 0.8), rgba(172, 255, 36, 0.85))"
          height="100vh"
          justify="flex-start"
          ref={this.registerRef}
        >
          <div style={{ margin: "3em 0 0 0" }}>
            <Heading
              style={{ margin: "0 0 1.5em 0" }}
              width="100%"
              color="#000"
              fontSize="46px"
            >
              IDENTIFY WHICH PERFORMANCE BEHAVIOURS AND SKILLS <br /> YOUR
              PUPILS CAN ENHANCE TO ACCELERATE THEIR LEARNING
            </Heading>
            <Heading width="100%" color="#000" fontSize="30px">
              WELCOME TO PERFORMANCE LEARNING
            </Heading>
          </div>
          <Row
            style={{ maxWidth: "1024px", boxShadow: "10px 10px 64px #0a0a0a" }}
            wrap="wrap"
            width="80%"
            justify="center"
          >
            <Col2 height="560px" background={schoolBg}>
              <div
                style={{
                  height: "100%",
                  width: "100%",
                  backgroundColor: "#00000085",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "flex-end",
                  padding: "2em",
                  minWidth: "400px",
                }}
              >
                <Heading style={{ textAlign: "left" }}>
                  It's time for you to register.
                </Heading>
              </div>
            </Col2>
            <Col2 height="560px">
              <FormContainer>
                <FormWrapper width="100%">
                  {/* <img className="logo" src={logo} alt="PLEX" /> */}
                  <p
                    style={{
                      textAlign: "left",
                      fontSize: "30px",
                      width: "100%",
                      padding: "0 16px",
                    }}
                    className="designation-title"
                  >
                    Register School
                  </p>
                  <form onSubmit={this.registerSchool}>
                    <InputWrapper>
                      <TooltipParagraph>
                        Who would you like Performance Learning for?
                        <a href="#">Multiple year groups?</a>
                        <span className="hover-tooltip">
                          Pick one year group, you can register learners with
                          different year groups in Performance Learning itself
                          (Performance Learning will show you how).
                        </span>
                      </TooltipParagraph>
                      <select
                        name="type"
                        data-arg="institutiontype"
                        required={true}
                        className="custom-select"
                        placeholder="Please choose your type of institution"
                        onChange={this.handleChange}
                      >
                        <option value="">
                          Who would you like Performance Learning for?
                        </option>
                        {institutionTypes.map((el) => (
                          <option value={el.id} key={`type-${el.id}`}>
                            {el.Name}
                          </option>
                        ))}
                      </select>
                    </InputWrapper>

                    <InputWrapper>
                      <p>Email</p>
                      <input
                        type="email"
                        id="email"
                        className="custom-textfield"
                        placeholder="Email Address"
                        required={true}
                        data-arg="email"
                        onChange={this.handleChange}
                      />
                    </InputWrapper>

                    <InputWrapper>
                      <p>Institution Name</p>
                      <input
                        type="text"
                        id="schoolname"
                        className="custom-textfield"
                        placeholder="School Name"
                        required={true}
                        data-arg="schoolname"
                        onChange={this.handleChange}
                      />
                    </InputWrapper>

                    <InputWrapper>
                      <p>Password</p>
                      <input
                        type="password"
                        id="password"
                        className="custom-textfield"
                        placeholder="Password"
                        required={true}
                        data-arg="password"
                        onChange={this.handleChange}
                      />
                    </InputWrapper>

                    <button
                      style={{ color: "#000", width: "100%" }}
                      className="green-button register-parent"
                      type="submit"
                    >
                      Register
                    </button>
                    <p className="already-registered">
                      ALREADY REGISTERED?{" "}
                      <span onClick={this.navigate.bind(this, "/login")}>
                        LOGIN HERE
                      </span>
                    </p>
                  </form>
                </FormWrapper>
              </FormContainer>
            </Col2>
          </Row>
        </Section>

        <Section
          justify="center"
          backgroundImage={`url(${resultsBg})`}
          height="55vh"
        >
          <Row
            style={{ maxWidth: "1024px" }}
            wrap="wrap"
            width="80%"
            justify="center"
          >
            <Col2 justify="center">
              <Heading
                style={{ textAlign: "left", lineHeight: "1.1" }}
                fontSize="56px"
              >
                <span>"</span>
                Accurate <br />
                <span>Insightful</span> <br /> Impressive
                <span>"</span>
              </Heading>
              <Heading
                style={{
                  textAlign: "left",
                  lineHeight: "1.2",
                  fontSize: "24px",
                }}
              >
                - Mr. Alastair Chirnside <br />
                Deputy Headmaster <span>- Harrow School</span>
              </Heading>
            </Col2>
            <Col2 height="auto">
              <div>
                <CheckedItem>
                  <i className="fa fa-check-circle-o" aria-hidden="true" />
                  <span>
                    Complimentary skills diagnostic and reporting licenses for
                    your school
                  </span>
                </CheckedItem>

                <CheckedItem>
                  <i className="fa fa-check-circle-o" aria-hidden="true" />
                  <span>15-Minutes to complete per pupil</span>
                </CheckedItem>

                <CheckedItem>
                  <i className="fa fa-check-circle-o" aria-hidden="true" />
                  <span>
                    Backed by 10 years of research &amp; developments with
                    university partners such as University college london, IOE
                  </span>
                </CheckedItem>

                <CheckedItem>
                  <i className="fa fa-check-circle-o" aria-hidden="true" />
                  <span>Serving 64,500 pupils across 3 countries</span>
                </CheckedItem>
              </div>
            </Col2>
          </Row>
          <button
            style={{
              padding: ".75em 2em",
              minWidth: "360px",
              marginTop: "-1.25em",
            }}
            className="green-button register"
            onClick={this.onScroll.bind(this, this.registerRef)}
          >
            Register
          </button>
        </Section>

        <Section
          backgroundColor="#111"
          justify="space-around"
          padding="0"
          height="50vh"
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Heading>Questions? Talk to us.</Heading>
            <BorderButton onClick={this.toggleCalendly}>
              Schedule a call
            </BorderButton>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <img
              style={{ display: "block", width: "200px" }}
              src={plexlogo}
              alt=""
            />
            <Heading style={{ fontSize: "15px" }} width="100%">
              PL EDUCATION IS A COMPANY REGISTERED IN ENGLAND AND WALES WITH
              COMPANY NO.09113777. <br />
              REGISTERED OFFICE: 34 SOUTH MOLTON STREET, LONDON, W1K 5RG, UNITED
              KINGDOM <br />
              <br />
              T: +44 (0) 207 409 5167 W:{" "}
              <a
                style={{ textDecoration: "none", color: "#fff" }}
                href="http://myperformancelearning.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                MYPERFORMANCELEARNING.COM
              </a>
            </Heading>
          </div>
        </Section>
      </Container>
    );
  }
}

export default withServices(PixlRegistration);



// WEBPACK FOOTER //
// ./src/pages/Onboard/Institution/India100k/IndiaRegistration.tsx